import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/Index.css';
import DesignWeb from './js/DesignWeb';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <DesignWeb />
  </React.StrictMode>
);

